import { randomInt, randomPassword } from '@10000/common'
import { useBreakpoints, useInstance, useRequest, useView } from '@10000/react'
import { InputScreen, signUpBackground, useBackground, useShell, useStack } from '../layout'
import { Avatar, Password } from '../forms'
import { Body, Box, Button, Google, H3 } from '../widgets'
import { Industry } from './account'
import { Subscriptions } from './payment'
import { assetUrl } from '../../utilities.js'
import { authenticate, authRedirectUri } from '../auth'

export const PasswordSetUp = ({ active, challenge, session, username, fromFreeSquiz, allowLinking }) => {
  const { setInstance } = useInstance()
  const { user: { id, avatar = randomInt(6) } = { } } = useView('tenant')
  const { replaceStack } = useStack()
  const request = useRequest('tenant')
  const { mobile } = useBreakpoints()

  useBackground().set(mobile => ({
    active,
    fade: false,
    ...signUpBackground(mobile, challenge !== 'NEW_PASSWORD_REQUIRED', true)
  }))
  useShell({ active, mode: challenge === 'NEW_PASSWORD_REQUIRED' ? 'logo narrow' : 'navigate narrow' })

  const setPassword = async ({ avatar, password }) => {
    if(challenge === 'NEW_PASSWORD_REQUIRED') {
      const { user } = await authenticate({ username, password, session })
      setInstance({ id: user.tenantId, region: user.region })
    } else {
      await request('passwordSet', { password })
      await request('avatarUpdated', { avatar })
      replaceStack(fromFreeSquiz ? Industry : Subscriptions, { props: { fromFreeSquiz } })
    }
  }

  const linkSocialAccount = provider => async () => {
    await authenticate({ username, password: randomPassword(), session })
    window.location.href = authRedirectUri('AP', provider, { link: true })
  }

  return (
    <InputScreen fade footerButton="Next" onSubmit={setPassword} formValues={{ avatar }}>
      {challenge === 'NEW_PASSWORD_REQUIRED'
        ? <video src={assetUrl('videos/create-account.mp4')} autoPlay muted playsInline loop style={{ width: 150 }} />
        : <Avatar
            edit={id !== undefined}
            name="avatar"
            size={mobile ? 'medium' : 'large'}
          />
      }
      <H3 align="center">Set up your password</H3>
      <Box fullWidth column alignItems="center" className="inputs-container">
        <Password
          useConfirmedPassword
          showPasswordRequirements
        />
      </Box>

      {allowLinking && <>
        <Body>or</Body>

        <Box gap={8} fullWidth>
          <Button
            fullWidth
            onClick={linkSocialAccount('Google')}
          >
            <Google />
          </Button>
        </Box>
      </>}
    </InputScreen>
  )
}